import script from "./DCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__